import Vue from "vue";
import VueRouter from "vue-router";
import Profile from "../views/Profile.vue";
import Logout from "../views/Logout.vue";
import Landing from "../views/LandingPage.vue";
import { BIconFileMedical } from "bootstrap-vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "landing",
    component: Landing,
  },
  {
    path: "/filemanagement/:tab",
    name: "filesMain",
    props: true,
  },
  {
    path: "/fileMain",
    redirect: "/",
    props: true,
  },
  {
    path: "/settings/:tab",
    name: "company",
    props: true,
  },

  {
    path: "/admin/:tab",
    name: "admin",
    props: true,
  },

  {
    path: "/profile/:id",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
